import { toast } from "react-toastify";

export const customToasts = {
  success(text) {
    toast.success(text ? text : "Выполнено успешно.");
  },
  error(text) {
    toast.error(
      text ? text : "Что-то пошло не так, но вы можете повторить попытку."
    );
  },
};
